import React from "react";
import { Link } from "react-router-dom";

function AccountSuccess() {
  return (
    <div className="account-success-container">
      <div className="account-success-content">
        <h5>Classes Added!</h5>
        <Link to="/faculty/dashboard" className="back-to-home-link">
          Back to Dashboard
        </Link>
      </div>
    </div>
  );
}

export default AccountSuccess;
